import { createFileRoute } from '@tanstack/react-router'
import PlusIcon from '~/components/icons/PlusIcon'
import { SellersPageLayout } from '~/components/routes/sellers/sellers-page-layout'
import { SellersPanel } from '~/components/routes/sellers/SellersPanel'
import { useRights } from '~/utils/hooks'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/sellers/sellers')({
  staticData: {
    permission: ['read', 'sellers'],
  },
  component: SellersTabPage,
})
withRoutePermissions(Route)

function SellersTabPage() {
  const isAdmin = useRights(['ADMIN'])

  return (
    <SellersPageLayout
      activeTab="sellers"
      actions={
        <AuthorizedButtonLink variant="contained" to="/sellers/new" disabled={!isAdmin}>
          <PlusIcon />
          Ajouter un vendeur
        </AuthorizedButtonLink>
      }
    >
      <SellersPanel />
    </SellersPageLayout>
  )
}
